import {db, deleteFileFromUrl} from "../config/firebaseConfig";
import {collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, updateDoc,} from "firebase/firestore";
import {Category} from "../model/Category";

export const getCategories = async (): Promise<Category[]> => {
  try {
    const categoryCollection = collection(db, "categories");
    const q = query(categoryCollection, orderBy("name", "desc"));
    const categorySnapshot = await getDocs(q);
    const categories: Category[] = [];
    categorySnapshot.forEach((doc) => {
      categories.push({
        uid: doc.id,
        ...doc.data(),
      } as Category);
    });
    return categories;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const getCategory = async (id: string): Promise<Category | null> => {
  try {
    const categoryDocRef = doc(db, "categories", id);
    const categoryDoc = await getDoc(categoryDocRef);
    if (categoryDoc.exists()) {
      return {
        ...categoryDoc.data(),
      } as Category;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching category by ID:", error);
    return null;
  }
};

export const insertCategory = async (
  category: any,
): Promise<string | undefined> => {
  try {
    const copy = { ...category };
    delete copy.imageFile;
    delete copy.uid;
    const id = category.name.toUpperCase();
    await setDoc(doc(db, "categories", id), copy);
    await updateCategory({ ...category, uid: id });
    return id;
  } catch (error) {
    console.error("Error insert category:", error);
  }
};

export const updateCategory = async (category: any): Promise<void> => {
  try {
    const copy = { ...category };
    const id = category.uid;
    delete copy.imageFile;
    delete copy.uid;
    const shopDocRef = doc(db, "categories", id);
    await updateDoc(shopDocRef, copy);
  } catch (error) {
    console.error("Error updating category:", error);
  }
};

export const deleteCategory = async (
  categoryId: string,
  url: string | undefined,
): Promise<void> => {
  try {
    if (url) {
      await deleteFileFromUrl(url);
    }
    await deleteDoc(doc(db, "categories", categoryId));
  } catch (error) {
    console.error("Error delete category:", error);
  }
};
